// frontend/src/pages/Home.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import { useWeb3 } from '../contexts/Web3Context';
import axios from 'axios';
import { ChevronRightIcon, BellIcon } from '@heroicons/react/24/outline';
import LoadingSpinner from '../components/LoadingSpinner';

function Home() {
  // const { account, isEligibleProposer, isBanned, eligibilityReason, connectWallet, isConnecting } =
  //   useWeb3();

  const [announcements, setAnnouncements] = useState([]);
  const [loadingAnnouncements, setLoadingAnnouncements] = useState(true);

  // お知らせ情報を取得
  useEffect(() => {
    const fetchAnnouncements = async () => {
      try {
        setLoadingAnnouncements(true);
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/announcements`);

        // 最新の3件のみを表示
        setAnnouncements(response.data.slice(0, 3));
        setLoadingAnnouncements(false);
      } catch (error) {
        console.error('お知らせ取得エラー:', error);
        setLoadingAnnouncements(false);
      }
    };

    fetchAnnouncements();
  }, []);

  return (
    <div className="text-center py-12">
      <h1 className="text-4xl font-bold text-indigo-600 dark:text-indigo-400 mb-4">
        YukichiCoin 投票システム
      </h1>
      <p className="text-xl text-gray-600 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
        yukichi.funで発行したコインを使った投票システムです。
        <br />
        提案・投票して、みんなで決めよう。
      </p>

      {/* 提案/トークン発行ボタン */}
      <div className="flex justify-center space-x-4 mb-8">
        <Link
          to="/proposals"
          className="bg-indigo-600 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-indigo-700"
        >
          提案一覧を見る
        </Link>
        <a
          href="https://yukichi.fun"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-white text-indigo-600 border border-indigo-600 px-6 py-3 rounded-md text-lg font-medium hover:bg-indigo-50"
        >
          コインを発行
        </a>
      </div>

      {/* お知らせセクション - 左寄せに変更 */}
      <div className="max-w-3xl mx-auto mb-8 bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden text-left">
        <div className="bg-indigo-50 dark:bg-indigo-900/30 px-4 py-3 border-b border-indigo-100 dark:border-indigo-800 flex items-center justify-between">
          <div className="flex items-center">
            <BellIcon className="h-5 w-5 text-indigo-600 dark:text-indigo-400 mr-2" />
            <h2 className="text-lg font-medium text-indigo-700 dark:text-indigo-300">
              最新のお知らせ
            </h2>
          </div>
          <Link
            to="/about?tab=announcements"
            className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 flex items-center"
          >
            すべて見る
            <ChevronRightIcon className="h-4 w-4 ml-1" />
          </Link>
        </div>

        <div className="divide-y divide-gray-200 dark:divide-gray-700">
          {loadingAnnouncements ? (
            <div className="flex justify-center py-6">
              <LoadingSpinner size="sm" />
            </div>
          ) : announcements.length > 0 ? (
            announcements.map(announcement => (
              <div key={announcement.id} className="p-4">
                <h3 className="font-medium text-gray-800 dark:text-gray-200 mb-1">
                  {announcement.title}
                </h3>
                <p className="text-sm text-gray-500 dark:text-gray-400 mb-2">
                  {new Date(announcement.publishedAt).toLocaleDateString('ja-JP')}
                </p>
                <div className="text-sm text-gray-600 dark:text-gray-300 line-clamp-2">
                  <div
                    dangerouslySetInnerHTML={{
                      __html: announcement.content.substring(0, 150) + '...',
                    }}
                  />
                </div>
                {/* <Link
                  to={`/about?tab=announcements`}
                  className="text-sm text-indigo-600 dark:text-indigo-400 hover:text-indigo-800 dark:hover:text-indigo-300 mt-2 inline-block"
                >
                  続きを読む
                </Link> */}
              </div>
            ))
          ) : (
            <div className="p-6 text-center text-gray-500 dark:text-gray-400">
              お知らせはありません
            </div>
          )}
        </div>
      </div>

      {/* {!account ? (
        <div className="mb-8">
          <button
            onClick={connectWallet}
            disabled={isConnecting}
            className="bg-indigo-600 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-indigo-700 disabled:bg-gray-400 mb-4"
          >
            {isConnecting ? 'ウォレット接続中...' : 'ウォレット接続'}
          </button>
          <p className="text-gray-500 dark:text-gray-400">
            MetaMaskなどのウォレットを使用して接続してください。
          </p>
        </div>
      ) : (
        <div className="mb-8">
          {isBanned ? (
            <p className="font-medium text-red-600 dark:text-red-400">
              アカウントがBANされているため、提案を作成できません。
            </p>
          ) : isEligibleProposer ? (
            <Link
              to="/proposals/create"
              className="bg-green-600 text-white px-6 py-3 rounded-md text-lg font-medium hover:bg-green-700"
            >
              新しい提案を作成
            </Link>
          ) : (
            <p className="font-medium text-yellow-600 dark:text-yellow-400">
              提案を作成するには、yukichi.funでトークンを発行または1,000
              LIDERU以上を保有している必要があります。
            </p>
          )}
        </div>
      )} */}
    </div>
  );
}

export default Home;
